import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/examinterceptor";

const getallquestions = async (payload) => {
  const { url } = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

const submitAnswer = async (payload) => {
  const { url,body} = payload;
  const result = await AxiosInterceptor.post(url,body);
  return result;
};

const getResults = async (payload) => {
  const { url} = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

const getExamdetails = async (payload) => {
  const { url} = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

const getanswershet = async (payload) => {
  const { url} = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

const singleanswer = async (payload) => {
  const { url} = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

export function* getQuestionall() {
  yield takeEvery(actions.GET_QUESTION_ALL_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(getallquestions, payload);
      if (res) {
        yield put({
          type: actions.GET_QUESTION_ALL_SUCCESS,
          data: res.data?.data[0]?.tests[0]?.question_paper_data,
          response:res?.data.data[0]
        });
        // } else if (res.status_code === 0) {
        //   yield put({
        //     type: actions.GET_QUESTION_ALL_ERROR,
        //     errorMessage: res?.message,
        //   })
        // }
      } else {
        yield put({
          type: actions.GET_QUESTION_ALL_ERROR,
          // errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_QUESTION_ALL_ERROR,
        errorMessage:
          error.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export function* submitanswersaga() {
  yield takeEvery(actions.SEND_ANSWER_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(submitAnswer, payload);
      if (res) {
        yield put({
          type: actions.SEND_ANSWER_SUCCESS,
          data: res,
        });
      } else {
        yield put({
          type: actions.SEND_ANSWER_ERROR,
          // errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.SEND_ANSWER_ERROR,
        errorMessage:
          error.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export function* getResult() {
  yield takeEvery(actions.GET_RESULT_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(getResults, payload);
      if (res) {
        yield put({
          type: actions.GET_RESULT_SUCCESS,
          data: res?.data?.data?.studentResults,
        });
      } else {
        yield put({
          type: actions.GET_RESULT_ERROR,
          // errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_RESULT_ERROR,
        errorMessage:
          error.response?.data?.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export function* getexamdetails() {
  yield takeEvery(actions.GET_EXAM_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(getExamdetails, payload);
      if (res) {
        yield put({
          type: actions.GET_EXAM_SUCCESS,
          data:res?.data?.data,
        });
        // } else if (res.status_code === 0) {
        //   yield put({
        //     type: actions.GET_QUESTION_ALL_ERROR,
        //     errorMessage: res?.message,
        //   })
        // }
      } else {
        yield put({
          type: actions.GET_EXAM_ERROR,
          // errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_EXAM_ERROR,
        errorMessage:
          error.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export function* getAnswersheet() {
  yield takeEvery(actions.GET_ANSWER_SHEET, function* ({ payload }) {
    try {
      const res = yield call(getanswershet, payload);
      if (res) {
        yield put({
          type: actions.GET_ANSWER_SHEET_SUCESS,
          data:res?.data?.data?.questions,
        });
        // } else if (res.status_code === 0) {
        //   yield put({
        //     type: actions.GET_QUESTION_ALL_ERROR,
        //     errorMessage: res?.message,
        //   })
        // }
      } else {
        yield put({
          type: actions.GET_ANSWER_SHEET_ERROR,
          // errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_ANSWER_SHEET_ERROR,
        errorMessage:error.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export function* getSinglesheet() {
  yield takeEvery(actions.GET_SINGLE_ANSWER, function* ({ payload }) {
    try {
      const res = yield call(singleanswer, payload);
      if (res) {
        yield put({
          type: actions.GET_SINGLE_ANSWER_SUCESS,
          data:res?.data?.data
        });
      } else {
        yield put({
          type: actions.GET_SINGLE_ANSWER_ERROR,
          errorMessage: res?.response.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_SINGLE_ANSWER_ERROR,
        errorMessage:error.message || "Something went wrong. Please try again later.",
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getQuestionall), fork(submitanswersaga),fork(getResult),fork(getexamdetails),fork(getAnswersheet),fork(getSinglesheet)]);
}
